import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type {
  HotelBookingKeyPayload,
  HotelRoomSelectionSession,
} from "@/components/main-services/hotels/checkout/hotel.checkout.type";
import type { AppliedCouponSessionPayload } from "@/types/coupon";
import { CheckoutPayload } from "@/hooks/booking-checkout/booking.checkout.helpers";

const HOTEL_CHECKOUT_PAYLOAD_STORAGE_KEY = "tovtrip_hotel_checkout_payload";
const HOTEL_BOOKING_KEY_STORAGE_KEY = "tovtrip_hotel_booking_key";
const HOTEL_ROOM_SELECTION_STORAGE_KEY = "tovtrip_hotel_room_selection";
const HOTEL_APPLIED_COUPON_STORAGE_KEY = "tovtrip_hotel_applied_coupon";

const noopStorage = {
  getItem: () => null,
  setItem: () => { },
  removeItem: () => { },
};

const hotelCheckoutStorage = createJSONStorage<CheckoutPayload | null>(
  () => (typeof window === "undefined" ? noopStorage : window.sessionStorage),
);
const hotelBookingKeyStorage = createJSONStorage<HotelBookingKeyPayload | null>(
  () => (typeof window === "undefined" ? noopStorage : window.sessionStorage),
);
const hotelRoomSelectionStorage =
  createJSONStorage<HotelRoomSelectionSession | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );
const hotelAppliedCouponStorage =
  createJSONStorage<AppliedCouponSessionPayload | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );

export const hotelCheckoutPayloadAtom =
  atomWithStorage<CheckoutPayload | null>(
    HOTEL_CHECKOUT_PAYLOAD_STORAGE_KEY,
    null,
    hotelCheckoutStorage,
    { getOnInit: true },
  );
export const hotelBookingKeyAtom =
  atomWithStorage<HotelBookingKeyPayload | null>(
    HOTEL_BOOKING_KEY_STORAGE_KEY,
    null,
    hotelBookingKeyStorage,
    { getOnInit: true },
  );
export const hotelRoomSelectionAtom =
  atomWithStorage<HotelRoomSelectionSession | null>(
    HOTEL_ROOM_SELECTION_STORAGE_KEY,
    null,
    hotelRoomSelectionStorage,
    { getOnInit: true },
  );
export const hotelAppliedCouponAtom =
  atomWithStorage<AppliedCouponSessionPayload | null>(
    HOTEL_APPLIED_COUPON_STORAGE_KEY,
    null,
    hotelAppliedCouponStorage,
    { getOnInit: true },
  );
